import axios from 'axios';
import globalConfig, {translateError} from '../../util/globalConfig';

export function getChatMessage (userId) {
    return new Promise(function (resolve, reject) {
        let url = globalConfig.APIURL + 'v1/chat?user_id=' + userId;
        axios.get(url)
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
            reject(translateError(error));
        });
    });
}

export function sendMessageText (data) {
    return new Promise(function (res, re) {
        let url = globalConfig.APIURL + 'v1/chat/send';
        axios.post(url, data).then(function (response) {
            res(response.data);
        }).catch(function (error) {
            re(translateError(error));
        });
    });
}

export function getChannelStatus (userId) {
    return new Promise(function (resolve, reject) {
        let url = globalConfig.APIURL + 'v1/chat/status?user_id=' + userId;
        axios.get(url)
            .then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
            reject(translateError(error));
        });
    });
}